import React, {FC, useContext} from 'react';
import {CatalogMenuSection} from '../CatalogMenuSection';
import style from './style.module.scss';
import {Box} from 'components/Grid';
import {MOCK_CATEGORIES} from 'modules/categories/constants';
import {PortalContext} from 'modules/portal/context/PortalContext';
import classNames from 'classnames';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectIsPortalVisible} from 'modules/portal/selectors';
import {MODALS} from 'modules/modals/constants';
import {hideModal} from 'modules/modals/thunks';

export const CatalogMenu: FC = () => {
    // TODO: раскоментить при интеграции
    // const categoriesList = useAppSelector(selectTreeCategoriesList);

    const dispatch = useAppDispatch();

    const {visibility} = useContext(PortalContext);

    const isMenuOpen = useAppSelector(selectIsPortalVisible(MODALS.CATALOG_MENU.name));

    // меню зачем-то сделано через модальное окно (???), приходится колхозить клик по оверлею
    const handleOverlayClick = () => {
        if (isMenuOpen) {
            dispatch(hideModal(MODALS.CATALOG_MENU.name));
        }
    };

    return (
        <>
            <div
                className={classNames(style.catalogMenu, {
                    [style.hidden]: !visibility,
                })}
            >
                <div className={style.catalogMenuBox}>
                    <Box>
                        <nav className={style.catalogMenuContent}>
                            <CatalogMenuSection categoriesList={MOCK_CATEGORIES} depth={1} />
                        </nav>
                    </Box>
                </div>
                <div className={style.overlay} onClick={handleOverlayClick} />
            </div>
        </>
    );
};
